import Vue from 'vue'
import VueHtml5Editor from 'vue-html5-editor'
import 'font-awesome/css/font-awesome.css'

// https://github.com/PeakTai/vue-html5-editor

Vue.use(VueHtml5Editor, {
  // 全局组件名称，使用new VueHtml5Editor(options)时该选项无效 
  // global component name
  name: "vue-html5-editor",
  // 自定义要显示的模块，并控制顺序
  // keep only the modules you want and customize the order.
  // can be used with hiddenModules together
  visibleModules: [
      "text",
      "color",
      "font",
      "align",
      "list",
      "link",
      "unlink",
      // "tabulation",
      // "image",
      "hr",
      // "eraser",
      "undo",
      "full-screen",
      // "info",
  ]
});